import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {
  AuthRoutingModule,
  NgSharedLibraryModule,
  AppConfigService,
  HomePageModule,
  ClientModule,
  EmployerSelectionState,
  RegistrationModule,
  LandingModule,
  AuthenticationState
} from 'ng-shared-library';
import {
  environment,
  authCodeFlowConfig,
  errorInterceptorSkipHeader,
  loadingInterceptorSkipHeader,
  loginRedirectSkipHeader
} from '../environments/environment';
import { OAuthModule } from 'angular-oauth2-oidc';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SafePipeModule } from 'safe-pipe';
import { NgxsModule } from '@ngxs/store';
import { NgxsStoragePluginModule, StorageOption } from '@ngxs/storage-plugin';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsFormPluginModule } from '@ngxs/form-plugin';
import { NgxsRouterPluginModule } from '@ngxs/router-plugin';

export function initConfig(appConfig: AppConfigService) {
  return () => appConfig.loadConfig();
}
@NgModule({
  declarations: [AppComponent],
  imports: [
    SafePipeModule,
    BrowserModule,
    AuthRoutingModule,
    AppRoutingModule,
    OAuthModule.forRoot(),
    // GtagModule.forRoot({ trackingId: environment.GoogleTrackingId, trackPageviews: false }),
    NgIdleKeepaliveModule.forRoot(),
    NgxsModule.forRoot([EmployerSelectionState, AuthenticationState], {
      developmentMode: !environment.production
    }),
    NgxsStoragePluginModule.forRoot({
      storage: StorageOption.SessionStorage,
      keys: []
    }),
    NgxsReduxDevtoolsPluginModule.forRoot({
      disabled: environment.production
    }),
    NgxsFormPluginModule.forRoot(),
    NgxsRouterPluginModule.forRoot(),
    NgSharedLibraryModule.forRoot(
      environment,
      authCodeFlowConfig,
      errorInterceptorSkipHeader,
      loadingInterceptorSkipHeader,
      loginRedirectSkipHeader
    ),
    HomePageModule,
    LandingModule,
    ClientModule,
    RegistrationModule,
    BrowserAnimationsModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initConfig,
      deps: [AppConfigService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
